
import {fixPageAfterDel} from '@/utils/utils'
import { EditModal, DetailDrawer, HotelCreateModal, StoreEditModal, BindAppModal, ChangeIndustryModal } from './components'

import columns from './tableConfig'
import {searchItems} from './searchFormConfig'

let searchCache = {}
import store from '@/store'
import { QueryTemplateList } from '@/apis/authResourceTemplate'
import { QueryShopIndex, ShopClose, ShopCreate, ShopDelete, ShopUpdate } from '@/apis/shop'
import {ZfbHotelCreate, ZfbHotelUpdate} from '@/apis/zfbHotel'
import { ZfbStoreCreate, ZfbStoreUpdate } from '@/apis/zfbStore'
import { AppSubscribeChange } from '@/apis/appSubscribe'

const enumsData = store.state.enumsStore.enumsData
const {ZfbStoreState} = enumsData
export default {
  name: 'Shop.Index',
  components: {EditModal, DetailDrawer, HotelCreateModal, StoreEditModal, BindAppModal,ChangeIndustryModal},
  data() {
    return {
      searchItems,
      searching: false,
      confirmGroupLoading: false,
      ZfbStoreState,
      columns,
      data: [],
      name: '',
      loading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100']
      },

      selectIndustry: null,
      showAppInfoModal: false,
      showEditModal: false,
      showDetailDrawer: false,
      targetApp:null,
      targetStoreApp:null,
      showCreateHotelModal: false,
      showStoreEditModal: false,
      showBindAppModal: false,
      showChangeIndustryModal: false,
      target: null,
      deviceStates : [
        {code: 0, name: '正常'},
        {code: 1, name: '禁用'},
        {code: 2, name: '删除'},
      ],
      templateList:[],
    }
  },
  watch: {
    '$route.params.search': async function(search) {
      if (search) {
        this.$refs.searchForm.handlerSearch()
      }
    }
  },
  created() {
    this.$nextTick(async () => {
      const { search } = this.$route.params
      // this.handleGetTemplateList()
      this.$refs.searchForm.handlerSearch()
    })
  },
  methods: {
    handleGetTemplateList(){
      let _this = this
      QueryTemplateList({page: 1, perPage: 100}).then(res=>{
        _this.templateList = res.collection
      })
    },
    // 查询设备
    async getShopIndex(page = 1, searchData) {
      try {
        this.loading = true
        // 确定搜索条件
        searchData = searchData || searchCache
        // 缓存搜索条件
        searchCache = searchData
        const {name, sn, zfbStoreName, operatorName, operatorPhone, address} = searchData
        const {collection: data, pageInfo} = await QueryShopIndex({
          name,zfbStoreName,operatorName,operatorPhone,address,
          sn,
          page,
          perPage: this.pagination.pageSize
        })
        this.data = data
        this.pagination.current = page
        this.pagination.total = pageInfo.total
      } catch (error) {
        console.log(error)
      }
      this.loading = this.searching = false
    },
    // 翻页
    handlePageTurn(pagination, filters, sorter) {
      const {current, pageSize} = pagination
      this.pagination.pageSize = pageSize
      this.getShopIndex(current)
    },
    queryTemplateName(code){
      return this.templateList.find(item=>item.id === code).name
    },

    // 提交编辑设备的信息
    async handleSubmitEdit(value) {
      let data = Object.assign({},value)
      try {
        const {id} = data
        if (!id) {
          await ShopCreate(data)
          await this.getShopIndex()
        } else {
          await ShopUpdate(data)
          await this.getShopIndex(this.pagination.current)
        }
        this.handlerCloseEditModal()
      } catch (error) {
      }
    },
    // 打开编辑设备模态框
    handlerOpenEditModal(data) {
      let info = null
      if (data){
        info = Object.assign({},data)
      }
      console.log(data)
      this.target = info
      this.showEditModal = true
    },
    // 关闭编辑设备模态框
    handlerCloseEditModal() {
      this.target = null
      this.showEditModal = false
    },

    // 删除店铺
    handlerDeleteShop(data) {
      const {id, zfbHotelProjectName} = data
      this.$confirm({
        title: '即将删除店铺，信息如下：',
        content: h => h('div', {style: {fontSize: '12px'}}, [
          h('p', {style: {margin: '5px 0 0'}}, `名称：${zfbHotelProjectName || '-'}`)
        ]),
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        confirmLoading: true,
        onOk: () => {
          return ShopDelete(id ).then(() => {
            this.pagination = fixPageAfterDel(this.pagination)
            this.getShopIndex(this.pagination.current)
          })
        }
      })
    },

    // 关闭店铺
    handlerCloseShop(data) {
      const {id, zfbHotelProjectName} = data
      this.$confirm({
        title: '即将关闭店铺，信息如下：',
        content: h => h('div', {style: {fontSize: '12px'}}, [
          h('p', {style: {margin: '5px 0 0'}}, `名称：${zfbHotelProjectName || '-'}`)
        ]),
        okText: '确认',
        okType: 'danger',
        cancelText: '取消',
        confirmLoading: true,
        onOk: () => {
          return ShopClose(id).then(() => {
            this.pagination = fixPageAfterDel(this.pagination)
            this.getShopIndex(this.pagination.current)
          })
        }
      })
    },
    handleGoToDetailsPage(record){
      this.$router.push({
        path: '/shop-mana/details',
        query: { id: record.id }
      })
    },
    handleShowInfo(data){
      this.selectIndustry = data
      this.showAppInfoModal = true
    },
    queryStateName(state){
      return this.ZfbStoreState.find(item=> state === item.code).name
    },

    handlerShowDetailDrawer(data){
      this.targetApp = data
      this.showDetailDrawer = true
    },
    handlerCloseDetailDrawer(){
      this.targetApp = null
      this.showDetailDrawer = false
    },
  //  支付宝酒店
    handlerCreateHotelShow(data){
      this.targetApp = data
      this.name = data.displayName
      this.showCreateHotelModal = true
    },
    handlerCreateHotelClose(){
      this.targetApp = null
      this.name = null
      this.showCreateHotelModal = false
    },

    async handleSubmitCreateHotel(value){
      let data = Object.assign({},value)
      const {id, industryId, zfbHotelIsTest, state, zfbHotelProjectName, appId, isSubscribe} = data
      try {
        await ZfbHotelCreate({id, industryId, zfbHotelIsTest, state, zfbHotelProjectName})
        if (appId){
          await AppSubscribeChange({yzStoreId: id,appId, isSubscribe})
        }
        await this.getShopIndex()
        this.handlerCreateHotelClose()
      } catch (error) {
      }
    },
    //  支付宝门店
    handlerCreateStoreShow(data){
      this.targetApp = data
      this.name = data.fullName
      this.targetStoreApp = data.zfbStoreShowVO?data.zfbStoreShowVO.zfbStoreInfo : null
      this.showStoreEditModal = true
    },
    handlerCreateStoreClose(){
      this.targetApp = null
      this.name = null
      this.targetStoreApp = null
      this.showStoreEditModal = false
    },
    async handleSubmitStoreEdit(value){
      let data = Object.assign({},value)
      data.adcId = data.adcId[2]
      let app = this.targetApp
      let param = {
        yzStoreId: app.id,
        zfbStoreInfo: data
      }
      try {
        const {zfbStoreShowVO} = app
        if (!zfbStoreShowVO) {
          await ZfbStoreCreate(param)
          await this.getShopIndex(this.pagination.current)
        } else {
          await ZfbStoreUpdate(param)
          await this.getShopIndex(this.pagination.current)
        }
        this.handlerCreateStoreClose()
      } catch (error) {
        this.handlerCreateStoreClose()
      }
    },
    //  支付宝门店
    handlerOpenBindAppModal(data){
      this.targetApp = data
      this.showBindAppModal = true
    },
    handlerHideBindAppModal(){
      this.targetApp = null
      this.showBindAppModal = false
    },
    async handleSubmitBindApp(value){
      let data = Object.assign({},value)
      const app = this.targetApp
      let param = {
        yzStoreId: app.id,
        isSubscribe: data.isSubscribe,
        appId: data.appId
      }
      try {
        await AppSubscribeChange(param)
        await this.getShopIndex(this.pagination.current)
        this.handlerHideBindAppModal()
      } catch (error) {
        this.handlerHideBindAppModal()
      }
    },


    //  支付宝门店
    handlerOpenChangeIndustryModal(data){
      this.targetApp = data
      this.showChangeIndustryModal = true
    },
    handlerHideChangeIndustryModal(){
      this.targetApp = null
      this.showChangeIndustryModal = false
    },
    async handleSubmitChangeIndustry(value){
      let data = Object.assign({},value)
      const app = this.targetApp
      let param = {
        id: app.id,
        industryId: data.industryId,
      }
      try {
        await ZfbHotelUpdate(param)
        await this.getShopIndex(this.pagination.current)
        this.handlerHideChangeIndustryModal()
      } catch (error) {
        this.handlerHideChangeIndustryModal()
      }
    },
  }
}
